export default __webpack_public_path__ + "static/media/Satwik_Jain.26475980.svg";